import React, {useState, useRef, useEffect} from 'react';
import HeadSub from '../../../components/comm/HeadSub';
import style from './LoginMain.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDpAuthRefeshTokenSimple, getDpAuthSignin } from '../../../assets/js/comm';
import URL, { IITP_OS_AT, SERVER_URL } from '../../../constants/url';
import logo from '../../../images/common/logo_landing_new.svg';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import MSG from '../../../constants/message';
import ToastPopup from '../../../components/comm/ToastPopup';

const LoginMain = () => {
    const navigate = useNavigate();

    const [usrId, setUsrId] = useState('');
    const [usrPswd, setUsrPswd] = useState('');
    const [saveIdFlag, setSaveIdFlag] = useState(false);
    const [pwView, setPwView] = useState(false); // password view
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const idInputRef = useRef(null);

    // 운영모드
    const operateMod = IITP_OS_AT;
    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const IITP_ID = "IITP_ID";
    const IITP_SAVE_ID_FLAG = "IITP_SAVE_ID_FLAG";
    const IITP_CRTFC_TKN = "IITP_CRTFC_TKN";

    const location = useLocation();
    const { state } = location;

    // 사용자 ID/PW
    const [userRequest, setUserRequest] = useState(
        { usrId: localStorage.getItem(IITP_ID), usrPswd: "", pushToken: "" });
    // 리프레쉬 토큰
    const [userRequest2, setUserRequest2] = useState(
        { crtfcTknVal: localStorage.getItem(IITP_CRTFC_TKN) }
    )
    /*  */
    const [loginUser, setLoginUser] = useState({});


    const handleSaveIdFlag = () => {
        localStorage.setItem(IITP_SAVE_ID_FLAG, !saveIdFlag);
        setSaveIdFlag(!saveIdFlag);
    };

    // 화면초기화 useRef 선언
    const isInitialRender = useRef(true);


    let idFlag;
    try {
        idFlag = JSON.parse(localStorage.getItem(IITP_SAVE_ID_FLAG));
    }
    catch (err) {
        idFlag = null;
    }

    const handlePwView = () => {
        setPwView(!pwView);
    }

    useEffect(() => {

        if (state?.refreshAt === false) {
            isInitialRender.current = false;
            //state.refreshAt = true;
        }
        if (idFlag === null) {
            setSaveIdFlag(false);
            idFlag = false;
        }
        if (idFlag !== null) setSaveIdFlag(idFlag);
        if (idFlag === false) {
            localStorage.setItem(IITP_ID, "");
            localStorage.setItem(IITP_CRTFC_TKN, "");
        } else {
            localStorage.setItem(IITP_ID, userRequest?.usrId);
            if (userRequest2.crtfcTknVal && isInitialRender.current) {
                handleFormSubmit2();
                isInitialRender.current = false;
            }
        }
        if (user && user?.usrHsptlMap?.length > 0) {
            navigate(URL.HOME_MAIN);
        }

    }, [idFlag]);

    const handleFormSubmit = () => {

        if (userRequest.usrId === undefined || userRequest.usrId === null || userRequest.usrId === '') {
            setToastMessage('아이디를 입력해 주세요');
            setToast(true);
            return;
        }

        if (userRequest.usrPswd === undefined || userRequest.usrPswd === null || userRequest.usrPswd === '') {
            setToastMessage('비밀번호를 입력해 주세요');
            setToast(true);
            return;
        }
        if (operateMod) {
            console.log("===========> IITP Operate Mode : OS Mode ");
            getDpAuthSignin(userRequest)
                .then(async (res) => {
                    //console.log( " ===========> handleFormSubmit / getDpAuthSignin :: ", res );
                    if (res?.accessToken !== undefined && res?.accessToken !== "") {
                        const jToken = res?.accessToken;
                        const refreshToken = res?.refreshToken;
                        const requestLoginUrl = "/signup/loginUser"; //"/signup/user";

                        const requestOptions = {
                            headers: {
                                Authorization: `Bearer ${jToken}`,
                            }
                            , params: {
                                refreshToken: refreshToken
                            }
                        }
                        const loginInfo = {
                            ...userRequest,
                            usrNm: res?.displayName
                        }

                        await axiosApi.post(requestLoginUrl, loginInfo, requestOptions)
                            .then((res) => {

                                if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                                    const iitpUser = res.data.result.iitpUser;

                                    if (["11", "12", "13", "14", "15"].includes(iitpUser.usrSeCd)) { // 정상 환자구분코드 checking~

                                        if (saveIdFlag) localStorage.setItem(IITP_ID, iitpUser?.usrId);
                                        setLoginUser(iitpUser);
                                        sessionStorage.setItem('loginUser', JSON.stringify(iitpUser));
                                        localStorage.setItem('jToken', jToken);
                                        if (saveIdFlag) {
                                            localStorage.setItem(IITP_CRTFC_TKN, refreshToken);
                                        }
                                        if (iitpUser.usrHsptlMap.length > 0) {
                                            // 정상케이스
                                            if( iitpUser.usrHsptlMap[0].paCd !== undefined && iitpUser.usrHsptlMap[0].paCd !== "" ) {
                                                // 신체활동계수 등록이 완료
                                                navigate(URL.HOME_MAIN);
                                            } else {
                                                // 신체활동계수 미등록일 경우 등록을 유도해야 함.
                                                navigate(URL.ACTIVITY_LEVEL_SELECT);
                                            }
                                        } else {
                                            // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결이 되어야 함
                                            setToastMessage('병원연결이 되지 않았습니다. 관리자에 문의해 주십시오!');
                                            setToast(true);
                                        }
                                    } else {
                                        // 비정상 유저정보가 로그인시도 하는 경우...
                                        setToastMessage("해당 앱을 사용 할수 없는 계정입니다. \n사용자구분 유형을 확인해주세요.");
                                        setToast(true);
                                        return false;
                                    }
                                } else {
                                    setToastMessage(MSG.ERR_SIGNIN);
                                    setToast(true);
                                }
                            })
                            .catch((err) => {
                                console.log(" ================> RCV_ERROR_SERVER ", err);
                            })
                    } else {
                        alert(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
                    }
                })
                .catch((err) => {
                    console.log(" ===========> err : ", err);
                    if (err.response.status === Number(CODE.RCV_BAD_UNAUTH)) {
                        console.log(" ==========> RCV_BAD_UNAUTH ");
                        //alert(MSG.ERR_UNSIGN + '\n' + MSG.ERR_PSSUSR + 'zzz');
                        // err.response
                        // data
                        // :
                        // code
                        // :
                        // "login-problem-occurred"
                        // message
                        // :
                        // "로그인 시에 문제가 발생하였습니다. 관리자에게 문의해 주시기 바랍니다."  >>> 인증서버 메시지를 그대로 사용시 문의이슈가 잦을수 있음.. 메시지 변경
                        setToastMessage(MSG.ERR_PSSUSR);
                        setToast(true);
                    }
                });

            // 2.  IITP데이터가 없을 경우에는, IITP사용 등록 페이지로 이동 !!
            // 로컬에서 필요시 사용!
        } else { // 로컬모드
            console.log("===========> IITP Operate Mode : Dev Mode ");

            const requestLoginUrl = "/signup/actionLoginUserLocal";

            axiosApi.post(requestLoginUrl, userRequest)
                .then((res) => { // 응답
                    if (res.data.resultCode === CODE.RCV_SUCCESS) {

                        const iitpUser = res.data.result.iitpUser;
                        //const iitpUserMenu = res.data.iitpUserMenu;

                        setLoginUser(iitpUser);
                        sessionStorage.setItem('loginUser', JSON.stringify(iitpUser));

                        if (saveIdFlag) localStorage.setItem(IITP_ID, iitpUser?.usrId);
                        // 정상케이스
                        if( iitpUser.usrHsptlMap[0].paCd !== undefined && iitpUser.usrHsptlMap[0].paCd !== "" ) {
                            // 신체활동계수 등록이 완료
                            navigate(URL.HOME_MAIN);
                        } else {
                            // 신체활동계수 미등록일 경우 등록을 유도해야 함.
                            navigate(URL.ACTIVITY_LEVEL_SELECT);
                        }

                    } else {
                        //alert(res.data.resultMessage);
                        setToastMessage('아이디 또는 비밀번호가 올바르지 않습니다');
                        setToast(true);
                    }
                })
                .catch(err => console.error("=============> Login Error Obj : ", err))
        }
    };

    /**
     * 세션유지 자동로그인
     * @returns {Element}
     */
    const handleFormSubmit2 = () => {

        getDpAuthRefeshTokenSimple(userRequest2.crtfcTknVal) // 간소화 버전 처리
            .then((data) => {
                //console.log( " ===========> handleFormSubmit2 / getDpAuthRefeshTokenSimple  :: ", data );
                const { accessToken, refreshToken } = data;
                localStorage.setItem("jToken", accessToken);
                const requestCdssUrl = SERVER_URL + "/signup/saveRefreshToken";

                const userReq = {
                    crtfcTknVal: refreshToken
                }
                const requestOptions = {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
                axiosApi.post(requestCdssUrl, userReq, requestOptions)
                    .then((resp) => {
                        if (Number(resp.data.resultCode) === Number(CODE.RCV_SUCCESS)) {

                            const iitpUser = resp.data.result.iitpUser;

                            localStorage.setItem("jToken", accessToken);
                            localStorage.setItem(IITP_CRTFC_TKN, refreshToken);
                            sessionStorage.setItem("loginUser", JSON.stringify(iitpUser));

                            if (["11", "12", "13", "14", "15"].includes(iitpUser.usrSeCd)) { // 정상 환자구분코드 checking~
                                if (iitpUser.usrHsptlMap.length > 0) {
                                    // 정상케이스
                                    //setTimeout( () => {
                                    // 정상케이스
                                    if( iitpUser.usrHsptlMap[0].paCd !== undefined && iitpUser.usrHsptlMap[0].paCd !== "" ) {
                                        // 신체활동계수 등록이 완료
                                        navigate(URL.HOME_MAIN);
                                    } else {
                                        // 신체활동계수 미등록일 경우 등록을 유도해야 함.
                                        navigate(URL.ACTIVITY_LEVEL_SELECT);
                                    }
                                    //}, 2000); // 실제 메인이 아니어서 리얼시 떼도 됨.
                                } else {
                                    // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결이 되어야 함
                                    //setTimeout( () => {
                                    setToastMessage('환자연동이 되지 않았습니다. 관리자에 문의해 주십시오!');
                                    setToast(true);
                                    //}, 2000); // 실제 메인이 아니어서 리얼시 떼도 됨.
                                    return false;
                                }
                            } else {
                                // 비정상 유저정보가 로그인시도 하는 경우...
                                setToastMessage("해당 앱을 사용 할수 없는 계정입니다. \n사용자구분 유형을 확인해주세요.");
                                setToast(true);
                                return false;
                            }
                        } else {
                            setToastMessage("리프레쉬 토큰 업데이트에 실패하였습니다.");
                            setToast(true);
                            localStorage.setItem("jToken", "");
                            localStorage.setItem(IITP_CRTFC_TKN, "");
                            sessionStorage.setItem("loginUser", JSON.stringify({}));
                            //sessionStorage.setItem('loginUserMenu', JSON.stringify({}));
                            navigate(URL.LOGIN_MAIN);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setToastMessage("인증정보 업데이트에 실패하였습니다.");
                        setToast(true);
                        localStorage.setItem("jToken", "");
                        localStorage.setItem(IITP_CRTFC_TKN, "");
                        sessionStorage.setItem("loginUser", JSON.stringify({}));
                        //sessionStorage.setItem('loginUserMenu', JSON.stringify({}));
                        navigate(URL.LOGIN_MAIN);
                    });
            })
            .catch(err => {
                console.log(err);
                setToastMessage('인증정보를 가져오지 못했습니다.');
                setToast(true);
                localStorage.setItem("jToken", "");
                localStorage.setItem(IITP_CRTFC_TKN, "");
                sessionStorage.setItem("loginUser", JSON.stringify({}));
                navigate(URL.LOGIN_MAIN);
            });
    }

    /**
     * 푸시 기능부
     */
    const getNativAlrmPermission = () => {
        // 알람권한 및 파이어베이스 푸시토큰 발급 함수
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView?.postMessage(
                JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
            );
        }
    };

    useEffect(() => {
        getNativAlrmPermission();
    }, []);

    useEffect(() => {

        const handleNativeMessage = async (event) => {
            try {
                // 메시지 파싱
                const data = typeof event.data === 'string'
                    ? JSON.parse(event.data)
                    : event.data;

                if (!data.type) {
                    console.warn('⚠️ type 필드가 없는 메시지 받음:', data);
                    console.warn('⚠️ 이는 RN에서 type을 누락한 것으로 보입니다');
                    return; // type이 없으면 처리하지 않음
                }

                if (data.type === 'NOTIFICATION_PERMISSION_RESULT') {
                    // RN 에서 결과로 넘겨주는 알람 권한 및 파이어베이스 토큰
                    if (data.granted && data.token) {
                        console.log('✅ 권한 허용됨, 토큰 받음:', data.token);

                        try {

                            setUserRequest({ ...userRequest, pushToken: data.token });
                            /*
                                최종적으로 토큰 받고 저장하는 로직 {data.token}
                            */
                            // console.log('📤 토큰 서버 전송 완료');

                        } catch (error) {
                            console.error('❌ 토큰 서버 전송 실패:', error);

                        }
                    } else if (data.granted && !data.token) {
                        console.log('⚠️ 권한은 허용됐지만 토큰이 없음 (재확인 메시지)');

                    } else {
                        console.log('❌ 권한 거부됨');
                    }

                } else if (data.type === 'NOTIFICATION_PERMISSION_STATUS') {
                    console.log('📋 권한 상태 확인 메시지 받음');
                    console.log('📋 granted:', data.granted);
                    console.log('📋 origin:', data.origin);

                    /* UI업데이트용 */
                }
            } catch (error) {
                console.error('메시지 처리 오류:', error);
            }
        };

        window.addEventListener('message', handleNativeMessage);
        return () => window.removeEventListener('message', handleNativeMessage);
    }, []);

    useEffect(() => {
        // inner-wrap 대신 첫 번째 입력 필드에 초점 이동
        idInputRef.current?.focus();
    }, []);

    return (
      <>
        <HeadSub title="아이디로 로그인" />
        <div id="sub-content" data-layout="white">
          <div className='inner-wrap' data-pad="normal" style={{ height: "calc(100vh - var(--sp-52))" }}>
            <div className={style['layout-box']}>

                <div className={style['logo-box']}>
                    <h1><img src={logo} alt="IITP" /></h1>
                </div>

                <div className={style['bundle-box']}>
                    <div className={style['mid-box']}>
                        <div className={style['input-box']}>
                        <span className={style['input-tit']}>아이디</span>
                        <span className={style['in-box']}>
                            <input type="text" value={userRequest?.usrId || ""} placeholder='아이디를 입력해 주세요'
                                onChange={e => setUserRequest({ ...userRequest, usrId: e.target.value })}
                                ref={idInputRef} />
                        </span>
                        </div>
                        <div className={style['input-box']}>
                        <span className={style['input-tit']}>비밀번호</span>
                        <span className={style['in-box']}>
                            <input type={pwView ? "text" : "password"} placeholder='비밀번호를 입력해 주세요'
                                onChange={e => setUserRequest({ ...userRequest, usrPswd: e.target.value })}
                                onKeyDown={(e) => { if (e.key === "Enter") handleFormSubmit(); }} />
                            <button className={style['pw-view-btn']}
                                    data-view={pwView ? "on" : "off"}
                                    onClick={handlePwView}
                                    aria-pressed={pwView}>
                            <span className='blind'>비밀번호 보기 전환</span>
                            </button>
                        </span>
                        </div>

                        <div className={style['chk-id-box']}>
                        <div className="chkbox-custom" data-chkbox="basic">
                            <input type="checkbox" name="chkId" id="chkId"
                                onChange={handleSaveIdFlag} checked={saveIdFlag} />
                            <label htmlFor="chkId">
                            <div className={style['txt-box']}>
                                <p>로그인 상태 유지</p>
                            </div>
                            </label>
                        </div>
                        </div>

                        <div className={style['fider-box']}>
                        <button onClick={() => navigate(URL.IDENTITY, { state: { moveToMenu: "findId" } })}>아이디 찾기</button>
                        <button onClick={() => navigate(URL.FIND_PASSWORD)}>비밀번호 찾기</button>
                        </div>
                    </div>

                    <div className={style['btns-box']}>
                        <button className='btn' data-btn-type="fill-main" data-btn-size='lg'
                        data-btn-width='full' onClick={handleFormSubmit}>
                        <span>로그인</span>
                        </button>
                        <button className='btn' data-btn-type="fill-main-sub" data-btn-size='lg'
                        data-btn-width='full' onClick={() => navigate(URL.IDENTITY)}>
                        <span>회원 가입</span>
                        </button>
                    </div>
                </div>



            </div>

            {toast && <ToastPopup message={toastMessage} setToast={setToast} position="center" opacity="90" />}
          </div>
        </div>
      </>
    );
};

export default LoginMain;
